import FolderOpenIcon from '@cp/src/assets/images/icons/FolderOpenIcon';
import { Typography } from '@navi/web-ui/lib/primitives';

const BankStatementNotAvailable = () => {
  return (
    <div className={'w-30 h-30 pt-40'}>
      <div className={'flex flex-col justify-center items-center'}>
        <div className={'mb-2'}>
          <FolderOpenIcon />
        </div>
        <Typography variant="p3" color="var(--navi-color-gray-c3)" className="mt-2">
          Bank Statement not available
        </Typography>
      </div>
    </div>
  );
};

export default BankStatementNotAvailable;
